module.exports = __webpack_public_path__ + "img/antes_despues_53.f7b0c8ec.png";